import { render, staticRenderFns } from "./CategoryFormComponent.vue?vue&type=template&id=ff2aed9c"
import script from "./CategoryFormComponent.vue?vue&type=script&lang=js"
export * from "./CategoryFormComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoryFormComponent.vue?vue&type=style&index=0&id=ff2aed9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports